
import { PartnersTranslations } from "../components/Forms/FormVMAPartners";
import { getSanityDataById } from "./getSanityDataById";

export const getPartnersById = async (): Promise<PartnersTranslations | null> => {
  return await getSanityDataById<PartnersTranslations>("partners");
};